import React from 'react';

const Contact = () => {
  return (
    <section id="contact" className="py-16 bg-shinsegae-gray">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            문의처 안내
          </h2>
          <p className="text-lg text-gray-600">
            WARP VPN 관련 문의 사항이 있으시면 언제든지 연락해주세요.
          </p>
        </div>

        <div className="bg-white rounded-lg shadow-md p-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">

            <div className="text-center">
              <h3 className="text-xl font-semibold text-gray-900 mb-2">
                PC보안 Service DESK
              </h3>
              <p className="text-lg text-gray-700 mb-1">PC보안업무 문의</p>
              <p className="text-sm text-gray-500 mb-4">신세계아이앤씨</p>
              <div className="space-y-2">
                <div className="flex items-center justify-center">
                  <span className="text-gray-600">02-3397-1312 or 1313</span>
                </div>
              </div>
            </div>

            <div className="text-center">
              <h3 className="text-xl font-semibold text-gray-900 mb-2">
                송승민
              </h3>
              <p className="text-sm text-gray-500 mb-4">신세계아이앤씨</p>
              <div className="space-y-2">
                <div className="flex items-center justify-center">
                  <span className="text-gray-600">smsong@shinsegae.com</span>
                </div>
                <div className="flex items-center justify-center">
                  <span className="text-gray-600">02-3397-1291</span>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-8 p-4 bg-blue-50 rounded-lg">
            <h4 className="font-semibold text-gray-900 mb-2 text-center">
              긴급 상황 시
            </h4>
            <p className="text-sm text-gray-600 text-center">
              업무 시간 외 긴급한 VPN 접속 문제가 발생할 경우,
              PC보안 Service DESK로 연락하시기 바랍니다.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
